import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { FormFieldInput, FormFieldContainer, CharsCount } from "../../../react-components/modals/modal-form-elements";
import { SetProfileStatePayload, SetProfileStateAction, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { GRAPHQL_TYPE_PERSON } from "@radivision/graphql";

interface MapStateProps {
  responsibility: string | null;
  isPerson: boolean;
}
interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

export type Props = MapStateProps & MapDispatchProps;

export const Component = (props: Props) => {
  const { setProfileState, responsibility, isPerson } = props;

  const [charsCount, setCharsCount] = React.useState<number>(0);
  const textareaId = "create-company-tagline";

  React.useEffect(() => {
    setCharsCount(responsibility ? responsibility.length : 0);
  }, [responsibility]);

  React.useEffect(
    function resizeTextarea() {
      const textarea = document.getElementById(textareaId);
      if (!textarea) {
        return;
      }
      try {
        textarea.setAttribute(
          "style",
          `min-height:100px;max-height:200px;height:${textarea.scrollHeight}px;overflow-y:auto;`,
        );
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
      } catch (error) {}
    },
    [textareaId],
  );

  if (!isPerson) return null;
  const tooltipText = "Brief description about your company";
  return (
    <FormFieldContainer>
      <label htmlFor="tagline">
        <span>Title:</span>
      </label>
      <FormFieldInput>
        <textarea
          rows={3}
          name="responsibility"
          id={textareaId}
          maxLength={70}
          value={responsibility}
          onChange={(e) => setProfileState({ responsibility: e.target.value })}
        />
        <CharsCount count={charsCount} limit={70} />
      </FormFieldInput>
    </FormFieldContainer>
  );
};

export const Container = ({ children }) => {
  return <div className="profile-tagline-input">{children}</div>;
};

const mapState = (state: AppState & ProfileModuleState) => ({
  responsibility: state.profile.responsibility,
  isPerson: state.profile.type === GRAPHQL_TYPE_PERSON,
});

const mapDispatch = {
  setProfileState: setProfileState,
};

export const Responsibility = connect(mapState, mapDispatch)(Component);
